module.exports = __webpack_public_path__ + "img/gomb-irjon.a0c53428.png";